import { useArticleStore } from '~/store/article';
import { type Article } from '~/types/article';
import { getArticleStats } from '~/composables/useArticleStats';

export default defineNuxtPlugin((nuxt) => {
  nuxt.hook('datalayer:pageInfo', ({ pageInfo }) => {
    if (pageInfo.pageType === 'article') {
      const getArticleInfo = () => {
        const article = useArticleStore().currentArticle as Article;
        const dayjs = useDayjs();

        if (article.id) {
          /*
           * Cached per article reference — see composables/useArticleStats.ts.
           * The new tracking-lib plugin calls this with the same article object,
           * so the body is parsed once total instead of twice per page view.
           */
          const { wordCount, characterCount } = getArticleStats(article);
          const articleBodyLength = article?.bodyLength || 0;
          const result = {
            availability: article.accessLevel === 'paywall' ? 'plus' : 'free',
            wall: ((article.body?.filter(i => !i.injected).length || 0) < articleBodyLength).toString(),
            wallType: article.accessLevel,
            subPublication: article.publication?.name || '',
            inLineContent: article.body?.map(i => i.type),
            title: article.title || article.originalTitle,
            articleInfo: {
              id: article.id,
              originalTitle: article.originalTitle || article.title,
              publishTimestamp: dayjs(article.firstPublishedAt).utc().unix(),
              modifyTimestamp: dayjs(article.updatedAt || article.firstPublishedAt).utc().unix(),
              wordCount,
              characterCount,
              category: article.categories?.[0]?.title,
              topic: article.topic?.name || '',
              tags: article.tags?.map(i => i.name) || [],
              authors: article.byline?.authors?.map(i => i.name) || [],
              dataLayout: article.dataLayout,
              lifespanScore: article.metadata?.levetid || '',
              newsScore: article.metadata?.nyhetsverdi || '',
              noList: article.metadata?.excludeFromStreams ? 'exclude' : 'include'
            }
          };
          const mainImage = useArticle().getMetaImage()?.src;
          if (mainImage.length > 0) {
            result.articleInfo.image = mainImage;
          }
          return result;
        }

        return {};
      };

      return { ...pageInfo, ...getArticleInfo() };
    } else if (pageInfo.pageType === 'frontpage') {
      const rtConfPub = useRuntimeConfig().public;
      const getFrontpageInfo = () => {
        const pathname = new URL(pageInfo.url, 'http://localhost').pathname;
        return {
          title: rtConfPub?.title || '',
          editionId: pathname === '/' ? rtConfPub?.front?.options?.id : pathname === '/front' ? rtConfPub?.front?.options?.sandBox?.id : ''
        };
      };
      return { ...pageInfo, ...getFrontpageInfo() };
    }
  });
});
